import { useMutation, useQueryClient } from '@gogame/query';

import { editCostModel } from 'scenes/Campaigns/sources/campaigns';

import { grids, details, updateCM } from '../queryKeyFactory';

export const useEditCostModel = () => {
  const queryClient = useQueryClient();
  const updateCostModalMutation = useMutation(updateCM(), editCostModel, {
    successMessage: () => 'Cost Model Updated',
    refresh: false,
  });

  const handleAction = async (params) => {
    await updateCostModalMutation.mutateAsync(params);
    queryClient.resetQueries({
      queryKey: grids(),
    });
    queryClient.resetQueries({
      queryKey: details(params.campaignId),
    });
  };

  return [handleAction, updateCostModalMutation];
};
